export default __webpack_public_path__ + "4a99f14ff669ab5bb55436d3909b33eb.png";